module.exports = __webpack_public_path__ + "img/logo.b0714a4e.png";